import React from 'react';
import '../../App.css';

import CabecalhoSelecao from '../../components/CabecalhoSelecao';
import Carregando from '../../components/Carregando';
import Times from '../../components/Times';
import Grupo from '../../components/Grupo';

import { env } from '../../constants';

import Auth from '../../services/Auth';
import Campeonato from '../../services/Campeonato';

import montarGrupos from '../../utils/montarGrupos';

export default class PrincipalScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuario: '',
      administrador: false,
      escolhaLivre: false,
      loading: true,
      erroSelecao: false,
      timeSelecionado: { id: 0, nome: '' },
      times: [],
      jogadores: [],
      selecaoRecente: false,
      jogadores1: [],
      jogadores2: [],
      grupo1: [],
      grupo2: [],
    };

    // BINDS
    this.selecionarTime = this.selecionarTime.bind(this);
    this.cancelarSelecaoTime = this.cancelarSelecaoTime.bind(this);
    this.selecionarJogador = this.selecionarJogador.bind(this);
    this.removerJogador = this.removerJogador.bind(this);
  }

  componentDidMount() {
    this.inicializar();
  }

  async inicializar() {
    const grupos = [];
    const jogadoresTotal = [];
    const { campeonato = env.CAMPEONATO } = this.props;
    const usuario = Auth.getUsuario().email;
    const administrador = await Campeonato.isAdministrador();
    const escolhaLivre = await Campeonato.isEscolhaLivre();
    console.log('admin', administrador);
    // Campeonato.cadastrarJogadores(campeonato);
    const titulo = await Campeonato.consultarTitulo(campeonato);
    const timesCampeonato = await Campeonato.listarTimesPorCampeonato(campeonato);
    const gruposCampeonato = await Campeonato.listarGruposPorCampeonato(campeonato);
    const promiseBase = gruposCampeonato && gruposCampeonato.length > 0 ? gruposCampeonato.map(async grupo => await Campeonato.listarJogadoresPorGrupo(grupo)) : [];
    for (const grupo of promiseBase) {
      grupos.push(await grupo);
    }
    grupos.map(grupo => jogadoresTotal.push(...grupo));
    // console.log('grupos', grupos);
    const selecao = await Campeonato.listarIdsJogadoresSelecaoPorCampeonato(campeonato);
    const jogadores = jogadoresTotal.filter(jogador => !selecao.includes(jogador.id));
    await this.atualizarGrupos(jogadores);
    await this.setState({ loading: false, times: timesCampeonato, selecaoRecente: false, usuario, administrador, escolhaLivre, titulo, jogadores });
  }

  async atualizarGrupos(jogadores) {
    const gruposTela = montarGrupos(jogadores);
    const jogadores1 = gruposTela[0].jogadores;
    const jogadores2 = gruposTela[1].jogadores;
    const grupo1 = gruposTela[0].grupos;
    const grupo2 = gruposTela[1].grupos;
    await this.setState({ jogadores1, jogadores2, grupo1, grupo2, erroSelecao: false });
  }

  async selecionarJogador(idTime, jogador) {
    this.setState({ erroSelecao: false });
    const { escolhaLivre, times, jogadores, grupo2 } = this.state;
    const { campeonato = env.CAMPEONATO } = this.props;
    const indexTime = times.findIndex(item => item.id === idTime);
    const permissaoSelecao = escolhaLivre || this.verificarSelecao(times, indexTime, 'i', jogador.categoria);
    // const permissaoSelecao = true; // Permite atuar sem a regra de verificação
    if (!permissaoSelecao && grupo2.length > 0) {
      this.setState({ erroSelecao: true });
      return false;
    }
    if (times[indexTime].jogadores) {
      times[indexTime].jogadores.push(jogador);
    } else {
      times[indexTime].jogadores = [jogador];
    }
    const novosJogadores = jogadores.filter(item => item.id !== jogador.id);
    Campeonato.selecionarJogador(campeonato, idTime, jogador);
    this.atualizarGrupos(novosJogadores);
    await this.setState({ times, jogadores: novosJogadores, selecaoRecente: true, erroSelecao: false });
  }

  verificarSelecao(times, indexTime, tipo, categoria) {
    // tipo = {i: inclusão, e: exclusão}

    // Ids dos times participantes da categoria A e B (veteranissimo 2020-1)
    // const timesAB = time =>
    //   time.id === 1 || time.id === 10 || time.id === 9 || time.id === 3 || time.id === 5 || time.id === 6 || time.id === 7 || time.id === 8;
    // calcula a qtde de jogadores que o time terá
    const qtdeTipo = tipo === 'i' ? 1 : -1;
    const qtdeSolicitada = times[indexTime].jogadores.filter(jog => jog.categoria === categoria).length + qtdeTipo;
    // console.log('times', times);
    if (tipo === 'i') {
      // if (categoria === 'C') {
        // verifica se há algum time com quantidade em desfalque
        const timesDesfalque = times.filter(time => qtdeSolicitada - time.jogadores.filter(jog => jog.categoria === categoria).length > 1);
        // Caso haja algum time nessa condição, retorna falso
        if (timesDesfalque.length >= 1) return false;
      // } else {
        // if (!timesAB(times[indexTime])) return false;
        // // verifica se há algum time com quantidade em desfalque
        // const timesDesfalque = times.filter(
        //   time => timesAB(time) && qtdeSolicitada - time.jogadores.filter(jog => jog.categoria === categoria).length > 1,
        // );
        // // Caso haja algum time nessa condição, retorna falso
        // if (timesDesfalque.length >= 1) return false;
      // }
    }
    if (tipo === 'e') {
      // if (categoria === 'C') {
        // verifica se há algum time com quantidade em desfalque
        const timesDesfalque = times.filter(time => time.jogadores.filter(jog => jog.categoria === categoria).length - qtdeSolicitada > 1);
        // Caso haja algum time nessa condição, retorna falso
        if (timesDesfalque.length >= 1) return false;
      // } else {
      //   if (!timesAB(times[indexTime])) return true;
      //   // verifica se há algum time com quantidade em desfalque
      //   const timesDesfalque = times.filter(
      //     time => timesAB(time) && time.jogadores.filter(jog => jog.categoria === categoria).length - qtdeSolicitada > 1,
      //   );
      //   // Caso haja algum time nessa condição, retorna falso
      //   if (timesDesfalque.length >= 1) return false;
      // }
    }
    // do contrário retorna true
    return true;
  }

  async removerJogador(idTime, jogador) {
    this.setState({ erroSelecao: false });
    const { escolhaLivre, times, jogadores } = this.state;
    const { campeonato = env.CAMPEONATO } = this.props;
    const indexTime = times.findIndex(item => item.id === idTime);
    const permissaoSelecao = escolhaLivre || this.verificarSelecao(times, indexTime, 'e', jogador.categoria);
    if (!permissaoSelecao) {
      this.setState({ erroSelecao: true });
      return false;
    }
    jogadores.push(jogador);
    const novosJogadores = times[times.findIndex(item => item.id === idTime)].jogadores.filter(item => item.id !== jogador.id);
    times[times.findIndex(item => item.id === idTime)].jogadores = novosJogadores;
    Campeonato.removerJogador(campeonato, idTime, jogador);
    this.atualizarGrupos(jogadores);
    await this.setState({ times, jogadores, selecaoRecente: false });
  }

  async selecionarTime(time) {
    await this.setState({ timeSelecionado: time, selecaoRecente: false, erroSelecao: false });
  }

  async cancelarSelecaoTime() {
    await this.setState({ timeSelecionado: { id: 0, nome: '' }, selecaoRecente: false, erroSelecao: false });
  }

  render() {
    const { usuario, administrador, loading, titulo, times, jogadores1, jogadores2, grupo1, grupo2, timeSelecionado, erroSelecao } = this.state;
    // const { loading, titulo, times, jogadores1, jogadores2, timeSelecionado, selecaoRecente } = this.state;

    if (loading) {
      return <Carregando />;
    }

    return (
      <div className="App">
        <CabecalhoSelecao usuario={usuario} administrador={administrador} titulo={titulo} />
        <div className="Body">
          <Times
            times={times}
            timeSelecionado={timeSelecionado}
            selecionarTime={this.selecionarTime}
            removerJogador={this.removerJogador}
            erro={erroSelecao}
          />
          <div className="GruposSelecao">
            <div className="TituloBody">
              {timeSelecionado.nome ? (
                <>
                  <p>{`${timeSelecionado.nome} - Escolha um jogador `}</p>
                  <button onClick={() => this.cancelarSelecaoTime()}>Fechar</button>
                </>
              ) : (
                <p>Grupos</p>
              )}
            </div>
            {jogadores1.length === 0 ? (
              <div className="SelecaoVazia">
                <p>Nenhum jogador para selecionar.</p>
              </div>
            ) : (
              <Grupo
                nome={grupo1}
                jogadores={jogadores1}
                selecionarJogador={this.selecionarJogador}
                // acaoAtiva={timeSelecionado.nome && !selecaoRecente}
                acaoAtiva={timeSelecionado.nome || false}
                idTime={timeSelecionado.id}
              />
            )}

            {jogadores2.length > 0 ? (
              <Grupo
                nome={grupo2}
                jogadores={jogadores2}
                selecionarJogador={this.selecionarJogador}
                // acaoAtiva={timeSelecionado.nome && !selecaoRecente}
                acaoAtiva={timeSelecionado.nome || false}
                idTime={timeSelecionado.id}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
